
/*Define properties for release note table header */
export const releaseNoteHeader = [
    {
        id: 'releaseVersion',
        name: 'Release Version',
        width: '20%',
    },
    {
        id: 'description',
        name: 'Description',
        width: '60%',
    },
    {
        id: 'releaseDate',
        name: 'Release Date',
        width: '20%'
    }
]